import React from 'react';
import Helmet from 'react-helmet';

const PageTitle = ({ children }) => (
    <Helmet
        defaultTitle={`Мої документи - ${config.BRAND_NAME} | ${config.DOMAIN_NAME}`}
        titleTemplate={`%s - ${config.BRAND_NAME} | ${config.DOMAIN_NAME}`}
    >
        <title>{children}</title>
    </Helmet>
);

export default PageTitle;
